import React from 'react'
import useAppSettings from '../../../../../lib/hooks/useAppSettings'
import { FlatPlanItem } from '../../../../../types'
import { ConfirmModal } from '../../../../shared/modal'
import { ModalSize } from '../../../../shared/modal/Modal/Modal'

type ConfirmApplyTemplateInactiveCourseModalProps = {
  /* */
  inactiveCourses: Array<FlatPlanItem>
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
}

const ConfirmApplyTemplateInactiveCourseModal = ({
  inactiveCourses,
  isOpen,
  onConfirm
}: ConfirmApplyTemplateInactiveCourseModalProps) => {
  const { text } = useAppSettings()
  const { course, coursePlural, term } = text
  const courseLabel = inactiveCourses.length === 1 ? course : coursePlural
  const title = `Inactive ${courseLabel} on Template`
  const courseList = inactiveCourses.map((item) => (
    <li key={item.id}>
      {item.subjectId} {item.courseNumber} {item.title} in {term.toLowerCase()} {item.groupTitle}
    </li>
  ))

  return (
    <ConfirmModal
      confirmText="Apply Template"
      isOpen={isOpen}
      onConfirm={onConfirm}
      size={ModalSize.MD}
      title={title}
    >
      The following {courseLabel.toLowerCase()} on this template{' '}
      {inactiveCourses.length === 1 ? 'is' : 'are'} no longer offered or active:
      <ul>{courseList}</ul>
      <p>
        <b>Are you sure you want to apply this template?</b>
      </p>
    </ConfirmModal>
  )
}

export default ConfirmApplyTemplateInactiveCourseModal
